import { Injectable } from '@angular/core';
import { grpc } from '@improbable-eng/grpc-web';
import { Observable, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoaderService } from './loader.service';
import { GrpcError } from '../shared-models/GrpcError';
import { SnackBarConfig, snackBarType } from '../constants/enum';
import { SnackbarService } from './snackbar.service';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root',
})
export class GrpcService {
  constructor(public loaderService: LoaderService,
    public snackbarService: SnackbarService,
  private toasterService: ToasterService) { }

  public grpcUnaryService(
    request: any,
    protoService: any,
    metadata?: grpc.Metadata,
    isShowMessage: boolean = false,
    key?: string | undefined,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (key != undefined) this.loaderService.startLoading(key);
      //console.log('status when grpc call has started : ' + this.loaderService.isLoading(key!));
      grpc.unary(protoService, {
        request: request,
        metadata,
        host: environment.serverURL,
        onEnd: (res) => {
          const { status, message } = res;

          if (status === grpc.Code.OK && message) {
            resolve(message.toObject());
          } else {
            reject(new Error(res.statusMessage));
          }
        },
      });
    }).catch(errorMessage => {
      if (isShowMessage) {
        this.toasterService.showCustomSnackbar(errorMessage, 'error', 5000);
      }
    })
      .finally(() => {
        if (key != undefined) this.loaderService.stopLoading(key);
        //console.log('status when grpc call has finished : ' + this.loaderService.isLoading(key!));
      });
  }

  public grpcUnaryServiceWithError(
    request: any,
    protoService: any,
    metadata?: grpc.Metadata,
    key?: string | undefined,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (key != undefined) this.loaderService.startLoading(key);
      grpc.unary(protoService, {
        request,
        metadata,
        host: environment.serverURL,
        onEnd: (res) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            resolve(message.toObject());
          } else {
            reject(new Error(res.statusMessage || 'Request failed.'));
          }
        },
      });
    }).finally(() => {
      if (key != undefined) this.loaderService.stopLoading(key);
    });
  }

  public grpcUnaryServiceWithSerializedResponse(
    request: any,
    protoService: any,
    metadata?: grpc.Metadata,
    isShowMessage: boolean = false,
    key?: string | undefined,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (key != undefined) this.loaderService.startLoading(key);
      grpc.unary(protoService, {
        request: request,
        metadata,
        host: environment.serverURL,
        onEnd: (res) => {
          const { status, message } = res;
          if (status === grpc.Code.OK && message) {
            resolve(message);
          } else {
            reject(new GrpcError(key!, res, request.toObject()));
            //reject(res);
          }
        },
      });
    })
      .catch((error) => {
        if (isShowMessage) {

          this.toasterService.showCustomSnackbar(error?.statusMessage, 'error', 5000);
        }
      })
      .finally(() => {
        if (key != undefined) this.loaderService.stopLoading(key);
        //console.log('status when grpc call has finished : ' + this.loaderService.isLoading(key!));
      });
  }

  public grpcStreamService(
    request: any,
    protoService: any,
    metadata?: grpc.Metadata,
    isShowMessage: boolean = false,
    key?: string | undefined,
  ): Observable<any> {
    let errorMessage: string | undefined;
    return new Observable((obs: any) => {
      if (key != undefined) this.loaderService.startLoading(key);
      grpc.invoke(protoService, {
        request: request,
        metadata,
        host: environment.serverURL,

        onMessage: (message: any) => {
          obs.next(message.toObject());
        },

        onEnd: (code: grpc.Code, msg: string | undefined, trailers: grpc.Metadata) => {
          if (code == grpc.Code.OK) {
            if (key != undefined) this.loaderService.stopLoading(key);
            obs.complete();
          } else {
            //obs.error(new GrpcError(key!, msg, request.toObject()));
            //obs.error(msg);
            if (isShowMessage) {
               this.toasterService.showCustomSnackbar(msg ?? '', 'error', 5000);
            }
            errorMessage = msg;
            if (key != undefined) this.loaderService.stopLoading(key);
            obs.error(new GrpcError(key!, msg, request.toObject()));
          }
        }
      });
    });
  }
}
